<template>
  <div class="bottom-link_list">
    <zcy-comp-link v-for="(item,index) in LinkList" :key="index" v-bind="item"></zcy-comp-link>
  </div>
</template>
<script>
import CompLinkItem from './comp-link-item';
export default {
  components: {
    'zcy-comp-link': CompLinkItem
  },
  data () {
    return {
      message: 'hello',
      LinkList: [
        {
          title: '平台服务',
          links: [
            {text: '职能客服', href: 'https://cschat.cloud.alipay.com/pcportal.htm?tntInstId=KMQNW3CN&scene=SCE00000041'},
            {text: '留言咨询', href: 'https://customer.zcygov.cn/feedback'}
          ]
        },
        {
          title: '采购指南',
          links: [
            {text: '政策说明', href: ''},
            {text: '购物流程', href: 'https://rule.zcygov.cn/web/site_1/2016/08/12/70.html'},
            {text: '常见问题', href: 'https://rule.zcygov.cn/web/site_1/ruleQuestion/index.html'},
            {text: '联系客服', href: 'https://cschat.cloud.alipay.com/pcportal.htm?tntInstId=KMQNW3CN&scene=SCE00000041'}
          ]
        },
        {
          title: '支付方式',
          links: [
            {text: '财政直接支付', href: 'https://rule.zcygov.cn/web/site_1/2016/08/15/78.html'},
            {text: '财政授权支付', href: 'https://rule.zcygov.cn/web/site_1/2016/08/15/78.html'},
            {text: '自有资金支付', href: 'https://rule.zcygov.cn/web/site_1/2016/08/15/78.html'}
          ]
        },
        {
          title: '品质保障',
          links: [
            {text: '比较说明', href: 'https://rule.zcygov.cn/web/site_1/2016/08/12/69.html'},
            {text: '发票制度', href: 'https://rule.zcygov.cn/web/site_1/2016/08/12/67.html'}
          ]
        },
        {
          title: '商家服务',
          links: [
            {text: '入驻须知', href: 'https://rule.zcygov.cn/web/site_1/2016/08/15/79.html'},
            {text: '入驻流程', href: 'https://rule.zcygov.cn/web/site_1/2016/08/15/80.html'},
            {text: '自营平台开发', href: ''}
          ]
        }
      ]
    };
  }
};
</script>
<style lang="less">
@import '../../assets/css/common.less';

.bottom-link_list {
  display: inline-flex;
  justify-content: space-between;
  width: 750px;
}
</style>



// WEBPACK FOOTER //
// src/components/bottom/comp-links.vue